export enum GROUPING_TYPES {
  NOT_GROUP = 'notGroup',
  TEXT_UNDER_IMAGE = 'textUnderImage',
  PARENT_CONTAINER = 'parentContainer'
}